export default __webpack_public_path__ + "static/media/maropost-logo.a4a4f9b9.svg";